import {Component, Input } from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";

@ComponentAsElement('v-product-details-page-element')
@Component({
  selector: 'v-product-details-page',
  templateUrl: './product-details-page.component.html'
})
export class ProductDetailsPageComponent {
  @Input() productCode;
  @Input() site;
  @Input() isAsm;
  @Input() isAnonymous;
  @Input() isCustomerLoyaltySystem;

  constructor() { }
}
